var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('van-empty',{staticClass:"custom-empty bg-white rounded-4",class:[_vm.size],attrs:{"image-size":_vm.$px2rem(48),"image":_vm.icEmpty,"description":"暂无数据"}})
}
var staticRenderFns = []

export { render, staticRenderFns }